import { useTranslation } from 'react-i18next';

import { LiveChatIntegration } from '@/shared/types/integration';

import CardBase from '../Components/CardBase';

const SettingUpCard = ({ integration }: { integration: LiveChatIntegration }) => {
  const { t } = useTranslation();

  return (
    <CardBase
      title={t('integrations.livechat.setting_up.title')}
      titleVariant="secondary"
      status={integration.status}
      active={integration.active}
    >
      <p role="status" className="text-sm text-muted-foreground">
        {t('integrations.livechat.setting_up.description')}
      </p>
    </CardBase>
  );
};

export default SettingUpCard;
